<template>
  <div class="file-toolbar d-flex align-items-center">
    <b-form-input
      class="flex-grow-1 search-input"
      :value="search"
      placeholder="Search file name..."
      debounce="500"
      @update="updateSearch"
    />
    <b-button
      v-if="canAddFolder"
      variant="outline-secondary"
      class="toolbar-button"
      aria-label="New folder"
      data-test="toolbar-new-folder"
      @click="$emit('new-folder')"
    >
      <b-icon icon="folder-plus" class="mr-2" />
      <span class="new-label">New folder</span>
    </b-button>
    <b-button
      v-if="canUpload"
      variant="primary"
      class="upload-button"
      aria-label="Upload"
      @click="$emit('upload')"
    >
      <b-icon icon="upload" class="mr-2" />
      <span>Upload</span>
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    search: { type: String, default: '' },
    canUpload: { type: Boolean, default: true },
    canAddFolder: { type: Boolean, default: false },
  },

  methods: {
    updateSearch(value) {
      this.$emit('search-change', value)
    },
  },
}
</script>

<style scoped>
.file-toolbar {
  gap: 12px;
}

.toolbar-button,
.upload-button {
  height: 50px;
  flex-shrink: 0;
  white-space: nowrap;
}

/* Tablets: room for the search box and two buttons, but New folder is icon only. */
@media (min-width: 576px) and (max-width: 767.98px) {
  .new-label {
    display: none;
  }

  .toolbar-button {
    min-width: 50px;
    padding-right: 0;
    padding-left: 0;
  }

  .toolbar-button svg {
    margin-right: 0 !important;
  }
}

/* Phones: the search box gets a row to itself, and the buttons share the next one. */
@media (max-width: 575.98px) {
  .file-toolbar {
    flex-wrap: wrap;
    gap: 8px;
  }

  .search-input {
    flex: 1 1 100%;
  }

  .toolbar-button,
  .upload-button {
    flex: 1 1 0;
    min-width: 0;
    height: 48px;
    padding-right: 8px;
    padding-left: 8px;
  }
}
</style>
